import { PAGE_MAIN } from '@/dmdrive/core/constants/pages';
import { PAGE_TOPIC } from '@/dmdrive/drive/constants/pages';

export class URLService {
  static main() {
    return PAGE_MAIN;
  }

  static topic(conferenceId: string) {
    return `${PAGE_TOPIC}/${conferenceId}`;
  }
}
